import { type FC } from "react";

import { EvaluationTypeEnum } from "@app_schema";

import { Badge, type BadgeColor } from "@styled/badge";

// Single source of truth for the evaluation-type pill, and for the label the
// projects inbox rows show as plain text. Mixed-case, rounded-full per spec — an
// eval type is a content classification, not a system/status tag.
const EVAL_TYPE_PILL: Record<
  EvaluationTypeEnum,
  { label: string; color: BadgeColor }
> = {
  [EvaluationTypeEnum.Comprehensive]: {
    label: "Comprehensive",
    color: "slate",
  },
  [EvaluationTypeEnum.Supplemental]: { label: "Supplemental", color: "slate" },
  [EvaluationTypeEnum.Followup]: { label: "Follow-up", color: "slate" },
};

export const evalTypeLabel = (type: EvaluationTypeEnum): string =>
  EVAL_TYPE_PILL[type].label;

export const EvalTypeBadge: FC<{
  type: EvaluationTypeEnum;
  // Trailing "+N" additional-records count, shown inline when present.
  counter?: number;
  // A failed record recolors the pill to signal the error state.
  tone?: "default" | "error";
}> = ({ type, counter, tone = "default" }) => {
  const { label, color } = EVAL_TYPE_PILL[type];

  return (
    <Badge pill color={tone === "error" ? "rose" : color}>
      {label}
      {counter !== undefined && counter > 0 && <span>+{counter}</span>}
    </Badge>
  );
};
